module.exports = __webpack_public_path__ + "static/media/Week2.8e938540.pdf";